import React, { useState } from 'react';
import { Modal, Form, Input, Alert } from 'antd';
import { toast } from 'react-toastify';
import { rejeter } from '../../../services/commandeAttestationDigitaleService';
import { useTranslation } from 'react-i18next';

export default function RejeterCommandeModal({ open, commande, onClose, onSuccess }) {
  const { t } = useTranslation('attestationsDigitales');
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const { motif } = await form.validateFields();
      setLoading(true);
      await rejeter(commande.commandeTrackingId, motif);
      toast.success(t('rejet.succes', { numero: commande.numeroCommande }));
      form.resetFields();
      onSuccess?.();
      onClose();
    } catch (err) {
      if (err?.errorFields) return;
      toast.error(err?.response?.data?.message || t('rejet.erreur'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={t('rejet.titre', { numero: commande?.numeroCommande })}
      open={open}
      onCancel={onClose}
      onOk={handleSubmit}
      okText={t('rejet.confirmer')}
      okButtonProps={{ danger: true }}
      confirmLoading={loading}
      destroyOnClose
    >
      <Alert
        type="warning"
        message={t('rejet.resume', { compagnie: commande?.compagnieRaisonSociale, quantite: commande?.quantite })}
        style={{ marginBottom: 16 }}
      />
      <Form form={form} layout="vertical">
        <Form.Item
          name="motif"
          label={t('rejet.motif')}
          rules={[{ required: true, message: t('rejet.motifObligatoire') }]}
        >
          <Input.TextArea rows={3} placeholder={t('rejet.motifPlaceholder')} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
